import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=2974f143&scoped=true&"
import script from "./Comparison.vue?vue&type=script&lang=js&"
export * from "./Comparison.vue?vue&type=script&lang=js&"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=2974f143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974f143",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2974f143')) {
      api.createRecord('2974f143', component.options)
    } else {
      api.reload('2974f143', component.options)
    }
    module.hot.accept("./Comparison.vue?vue&type=template&id=2974f143&scoped=true&", function () {
      api.rerender('2974f143', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Comparison.vue"
export default component.exports